module.exports = __webpack_public_path__ + "img/boden.a97c0c4c.png";